import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryReducer(state = initialState.reportcategories, action) {
  if (action.type === types.LOAD_REPORT_CATEGORY_DATA_SUCCESS) {
    return action.reportcategories;
  }
  return state;
}
